import React, { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
  useTheme
} from '@material-ui/core';

import { appMessages } from '../../translations';

export default function AlertDialog({
  open,
  text,
  title,
  onAccept,
  onCancel
}: {
  /** Whether the dialog is currently open and shown to the user. */
  open: boolean;
  /** The dialog title to be shown to the user. */
  title: string;
  /** The dialog description text to be shown to the user. */
  text: ReactNode | string;
  /** A callback invoked when the user clicks the confirm button. */
  onAccept: () => void;
  /** A callback invoked when the user clicks the cancel button. */
  onCancel: () => void;
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const {formatMessage} = useIntl();
  return (
      <Dialog
          open={open}
          onClose={onCancel}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen={fullScreen}
      >

        {title ? <DialogTitle id="alert-dialog-title">{title}</DialogTitle> : null}

        <DialogContent id="alert-dialog-description">
          {typeof text === 'string' ? <DialogContentText>{text}</DialogContentText> : text}
        </DialogContent>

        <DialogActions>
          <Button onClick={onCancel} color="primary">
            {formatMessage(appMessages['app.cancel'])}
          </Button>
          <Button onClick={onAccept} color="secondary" autoFocus={true}>
            {formatMessage(appMessages['app.ok'])}
          </Button>
        </DialogActions>

      </Dialog>
  );
}
